import { deserialize } from 'cerialize'
import { ShortDataModel, PartnerFullModel } from 'Models'
import { Id } from 'Src/types/aliases'
import { DATE_AND_TIME_FORMAT_REVERSE } from 'Constants/Global'
import moment from 'moment/moment'
import { FieldNames } from 'Constants/FieldNames'

type TerritorialBank = {
	id: number
	name: string
	code: string
}

type Manager = {
	id: number
	name: string
	first_name: string
	last_name: string
	middle_name: string
	territorial_bank: TerritorialBank
}

type City = {
	id: number
	name: string
	is_deleted: boolean
	region: ShortDataModel
}

export class DepartmentModel {
	@deserialize public id: Id
	@deserialize public partner: PartnerFullModel
	@deserialize public kind: string
	@deserialize public active: boolean
	@deserialize public name: string
	@deserialize public address: string
	@deserialize public manager: Manager
	@deserialize public city: City
	@deserialize public use_partner_products: boolean
	@deserialize public sber_mq_product_ids: number[]
	@deserialize public inn?: string
	@deserialize public ogrn?: string
	@deserialize public kpp?: string
	@deserialize public created_at: string
	@deserialize public updated_at: string
	@deserialize public edited_by_rukovoditel: string

	public get created(): string | undefined {
		return moment(this?.created_at).format(DATE_AND_TIME_FORMAT_REVERSE)
	}

	public get updated(): string | undefined {
		return moment(this?.updated_at).format(DATE_AND_TIME_FORMAT_REVERSE)
	}

	@deserialize public permissions: {
		editable_attributes: FieldNames[]
	}
}
